"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Visible = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M11.9998,4.9998 C17.0418,4.9998 19.8588,9.4228 20.8368,11.3238 C21.0538,11.7468 21.0538,12.2528 20.8368,12.6758 C19.8588,14.5768 17.0418,18.9998 11.9998,18.9998 C6.9588,18.9998 4.1408,14.5768 3.1638,12.6758 C2.9468,12.2528 2.9468,11.7468 3.1638,11.3238 C4.1408,9.4228 6.9588,4.9998 11.9998,4.9998 Z M11.9998,5.9998 C7.5098,5.9998 4.9468,10.0428 4.0528,11.7818 C3.9828,11.9178 3.9828,12.0818 4.0528,12.2188 C4.9468,13.9568 7.5098,17.9998 11.9998,17.9998 C16.4898,17.9998 19.0528,13.9568 19.9468,12.2188 C20.0168,12.0818 20.0168,11.9178 19.9468,11.7818 C19.0528,10.0428 16.4898,5.9998 11.9998,5.9998 Z M12,8.5 C13.93,8.5 15.5,10.07 15.5,12 C15.5,13.93 13.93,15.5 12,15.5 C10.07,15.5 8.5,13.93 8.5,12 C8.5,10.07 10.07,8.5 12,8.5 Z M12,9.5 C10.622,9.5 9.5,10.621 9.5,12 C9.5,13.379 10.622,14.5 12,14.5 C13.378,14.5 14.5,13.379 14.5,12 C14.5,10.621 13.378,9.5 12,9.5 Z", fillRule: "evenodd" })));
};
Visible.displayName = 'Visible';
exports.default = Visible;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Visible.js.map